import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PaymentLayout from './components/Payment/PaymentLayout';
import PaymentHome from './pages/Payment/PaymentHome';
import PaymentProduct from './pages/Payment/PaymentProduct';
import PaymentCheckout from './pages/Payment/PaymentCheckout';
import PaymentSuccessPage from './pages/Payment/PaymentSuccess';
import PaymentCancel from './pages/Payment/PaymentCancel';
import PaymentCGV from './pages/Payment/PaymentCGV';
import PaymentMentions from './pages/Payment/PaymentMentions';
import PaymentPrivacy from './pages/Payment/PaymentPrivacy';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PaymentLayout>
          <Routes>
            <Route path="/payment" element={<PaymentHome />} />
            <Route path="/payment/product" element={<PaymentProduct />} />
            <Route path="/payment/checkout" element={<PaymentCheckout />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/payment/cgv" element={<PaymentCGV />} />
            <Route path="/payment/mentions-legales" element={<PaymentMentions />} />
            <Route path="/payment/confidentialite" element={<PaymentPrivacy />} />
            <Route path="*" element={<Navigate to="/payment" replace />} />
          </Routes>
        </PaymentLayout>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
